import { useRef, useState } from "react";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { uploadToCloudinary } from "@/lib/upload";

export default function ImageField({ label, value, onChange, folder = "uploads" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const url = await uploadToCloudinary(file, folder);
      onChange(url);
      toast.success("ছবি আপলোড হয়েছে");
    } catch (err) {
      toast.error(err.message || "আপলোড ব্যর্থ");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium text-stone-600 mb-1.5">{label}</label>}
      <div className="flex items-start gap-3">
        <div className="h-20 w-20 shrink-0 rounded-lg border border-stone-200 bg-stone-50 overflow-hidden grid place-items-center">
          {value ? (
            <img src={value} alt="preview" className="h-full w-full object-cover" />
          ) : (
            <ImageIcon className="h-6 w-6 text-stone-300" />
          )}
        </div>
        <div className="flex-1 space-y-2">
          <input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="ছবির URL"
            className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm focus:outline-none focus:border-[var(--c-secondary)]"
          />
          <button
            type="button"
            onClick={() => ref.current?.click()}
            disabled={busy}
            className="inline-flex items-center gap-2 rounded-lg bg-stone-100 hover:bg-stone-200 px-3 py-1.5 text-sm text-stone-700 transition-colors disabled:opacity-60"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
            {busy ? "আপলোড হচ্ছে..." : "আপলোড করুন"}
          </button>
          <input ref={ref} type="file" accept="image/*" onChange={onFile} className="hidden" />
        </div>
      </div>
    </div>
  );
}
